module.exports = __webpack_public_path__ + "media/images/ln/constellation_01-b7a24338e2525237a65694acc8ea1267.png";